var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackplusicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23071 9.5C4.89293 9.5 4.61923 9.2263 4.61923 8.88852V1.11148C4.61923 0.773698 4.89293 0.5 5.23071 0.5C5.56849 0.5 5.84219 0.773698 5.84219 1.11148V8.88852C5.84219 9.2263 5.56849 9.5 5.23071 9.5Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11923 5.61148H1.34219C1.00441 5.61148 0.730713 5.33778 0.730713 5C0.730713 4.66222 1.00441 4.38852 1.34219 4.38852H9.11923C9.45702 4.38852 9.73071 4.66222 9.73071 5C9.73071 5.33778 9.45702 5.61148 9.11923 5.61148Z",
    fill: "#current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackplusicon);
export default __webpack_public_path__ + "static/media/Blackplusicon.de80bef87f93c279828bf598bef6323e.svg";
export { ForwardRef as ReactComponent };